class CompaniesList {
  constructor() {

    if(document.querySelector('.companies--list') != null && document.querySelector('.companies--list') != undefined) {
      this.setEvents();
    }
  }

  setEvents() {

    var companies = document.querySelectorAll('.companies--list');

    if(companies != null && companies != undefined) {

      companies.forEach(c => {

        var compare = c.querySelector('.companies--list__compare');

        function showCompare() {
          compare.classList.add('active');
        
          // simulação de empresas selecionadas

          var slots = compare.querySelectorAll('.compare__slot');

          for (var i = 0; i < 2; i++) {
            slots[i].classList.add('active');
          }

        }

        function hideCompare() {
          compare.classList.remove('active');
        }
        
  
        var checkBoxes = c.querySelectorAll('.compare-checkbox');
        
        if(checkBoxes != null && checkBoxes != undefined) {
          checkBoxes.forEach(checkbox => {
            checkbox.addEventListener('change', function() {
              var activeCheckBoxes = 0;
              if(checkbox.checked) {
                activeCheckBoxes++;
              }
              if(activeCheckBoxes >= 1) {
                showCompare();
              } else {
                hideCompare();
              }
            });
          });
        }

      });

    }
    
  }

}

$(document).ready(function() {
  const companiesList = new CompaniesList();
});
